
import * as React from 'react';

import { DataGrid } from '@process-advisor/process-miner/eventLog/transformationDataGrid';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

type Props = {
    setNextDisabled: (value: boolean) => void;
    setSaveDisabled: (value: boolean) => void;
    setDeleteDisabled: (value: boolean) => void;
    step: number;
};

const columnDefs = [
    {headerName: "Field", field: "field",  sortable: false, minWidth: 80},
    {headerName: "Mapping", field: "mapping",  sortable: false, minWidth: 80},
    {headerName: "Data Type", field: "datatype",  sortable: false, minWidth: 80},
    {headerName: 'Status', field: 'status',  sortable: false,  minWidth: 40},
    {headerName: 'Work Item', field: 'work_item', sortable: false,  minWidth: 200},
];

export const TransformationGrid: React.FC<Props> = ({
    setNextDisabled,
    setSaveDisabled,
    setDeleteDisabled,
    step,
}) =>{
    const [data, setData] = React.useState([]);

    React.useEffect(() => {
        const listener = () => {
            setData(apiProvider.retrieveDataTransformation());
        };

        apiProvider.on(Event.updateDataTransformation, listener);
        return () => {
            apiProvider.off(Event.updateDataTransformation, listener);
        };
    },);    

    return (
        <DataGrid
            rows={data}
            columns={columnDefs}
            step={step}
            setNextDisabled={setNextDisabled}
            setSaveDisabled={setSaveDisabled}
            setDeleteDisabled={setDeleteDisabled}
            height="250px" />
    );
};
